// Shared iconography. The bullseye target is the app's motif — used subtly in
// the nav brand and empty/hero states. Keep usage restrained.

export const TargetIcon = ({ className = "h-6 w-6", strokeWidth = 1.75 }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="5.5" />
    <circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" />
  </svg>
);

export default TargetIcon;
